<template>
    <!-- Start Navbar Area -->
    <header id="header" :class="['headroom', {'is-sticky': isSticky}]">
        <div class="startp-nav">
            <div class="container">
                <nav class="navbar navbar-expand-md navbar-light">
                    <router-link class="navbar-brand" to="/">
                        <img src="../../assets/SMATIVOS-LIGHT.jpg" alt="logo" width="120" height="auto"/>
                    </router-link>

                    <b-navbar-toggle target="navbarSupportedContent"></b-navbar-toggle>


                    <b-collapse class="collapse navbar-collapse mean-menu" id="navbarSupportedContent" is-nav>
                        <ul class="navbar-nav nav ml-auto">
                            <li class="nav-item">
                                <router-link class="nav-link active" to="/">
                                    Home
                                </router-link>

                            </li>

                            <li class="nav-item">
                                <a href="#" class="nav-link">Solutions <feather type="chevron-down"></feather></a>
                                <ul class="dropdown_menu">
                                    <li class="nav-item">
                                        <router-link to="/home-automation" class="nav-link">Home Automation</router-link>
                                    </li>
                                    
                                    <li class="nav-item">
                                        <router-link to="/fleet-and-telematics" class="nav-link">Fleet & Telematics</router-link>
                                    </li>

                                    <li class="nav-item">
                                        <router-link to="/energy" class="nav-link">Energy</router-link>
                                    </li>

                                    <li class="nav-item">
                                        <router-link to="/smart-city" class="nav-link">Smart City</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item"><a href="#" class="nav-link">About <feather type="chevron-down"></feather></a>
                                <ul class="dropdown_menu">
                                    <li class="nav-item">
                                        <router-link to="/company" class="nav-link">Company</router-link>
                                    </li>
                                    
                                    <li class="nav-item">
                                        <router-link to="/how-we-work" class="nav-link">How We Work</router-link>
                                    </li>
                                    
                                    <li class="nav-item">
                                        <router-link to="/partners" class="nav-link">Partners</router-link>
                                    </li>
                                    
                                    <li class="nav-item">
                                        <router-link to="/team" class="nav-link">Join our Team</router-link>
                                    </li>
                                    
                                    <li class="nav-item">
                                        <router-link to="/contact" class="nav-link">Contact</router-link>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </b-collapse>

                    <div class="others-option">
                        <a href="#" class="btn btn-light">Get Started</a>
                        <a href="#" class="btn btn-primary">Login</a>
                    </div>
                </nav>
            </div> 
        </div>
    </header>
    <!-- End Navbar Area -->
</template>

<script>
export default {
    name: 'Header',
    data(){
        return {
            isSticky: false
        }
    },

    mounted() {
        const that = this;
        window.addEventListener('scroll', () => {
            let scrollPos = window.scrollY;
            // eslint-disable-next-line no-console
            if(scrollPos >= 100){
                that.isSticky = true;
            } else {
                that.isSticky = false;
            }
        })
    },

    computed: {
        shoppingCart(){
            return this.$store.state.cart;
        }
    }
}
</script>